$('.js-popup').click(function (e) {
    e.preventDefault();
    closePopups();
    let modal = $(this).attr('href');
    openModal(modal)
});

$('.js-popup-close').click(function (e) {
    e.preventDefault();
    closePopups();
});

$(document).mousedown(function (e) {
    let targetBlock = $('.popup_active .popup__wrap');
    if (targetBlock.has(e.target).length === 0) {
        closePopups();
    }
});

$(document).keydown(function (e) {
    if (e.code == 'Escape') {
        closePopups();
    }
});

export function openModal(modalId) {
    $('body').addClass('o-hidden');
    $(modalId).addClass('popup_active');
}

export function closePopups() {
    $('body').removeClass('o-hidden');
    $('.popup').removeClass('popup_active');
}
